var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","md2":""}},[_c('v-flex',[_c('h4',[_vm._v(_vm._s(_vm.title))])]),_vm._l((_vm.menus),function(menu){return _c('v-flex',{key:menu.title},[_c('a',{attrs:{"href":menu.link}},[_vm._v(_vm._s(menu.title))])])})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }